export const swiperLinks = [
  {
    title: 'Ejaculação precoce',
    href: '/ejaculacao-precoce'
  },
  {
    title: 'Cuidados com a pele e cabelo',
    href: '/dermatologia'
  },
  {
    title: 'Problemas de ereção',
    href: '/disfuncao-eretil'
  },
  {
    title: 'Libido em baixa',
    href: '/perda-de-libido'
  }
]

export const swiperLinksSmartFit = [
  {
    title: 'Cuidados com a sexualidade',
    href: '/consultar'
  },
  {
    title: 'Cuidados com a pele e cabelo',
    href: '/consultar'
  }
]
